module.exports = __webpack_public_path__ + "static/bg07-bc0c867ad4d9c6553ddb13583027f453.jpg";